import { useQuery } from 'react-query';
import quoterApiInstance from '../../api/quoterApiInstance';
import { QUERY_KEYS, QUERY_CONFIG } from '../../constants/reactQuery';

const fetchFavoritePlan = async (id) => {
    const { data } = await quoterApiInstance.get(`/my-favorite-plans/${id}`);
    // Body shape: { data: {...plan}, message, status }. Se devuelve entero, igual
    // que en useFavoritePlans, para que el consumidor lea `data` o `message`.
    return data;
};

/**
 * GET /my-favorite-plans/:id
 *
 * Trae un plan favorito puntual; lo usa el formulario en modo edición para
 * hidratar el contexto. Deshabilitada mientras no haya `id` (modo crear).
 */
export const useFavoritePlan = (id, options = {}) => {
    return useQuery(
        QUERY_KEYS.favoritePlans.detail(id),
        () => fetchFavoritePlan(id),
        {
            ...QUERY_CONFIG,
            ...options,
            enabled: Boolean(id) && (options.enabled ?? true),
            onError: (error) => {
                console.error('Error fetching favorite plan:', error);
                options.onError?.(error);
            },
        }
    );
};

export default useFavoritePlan;
